var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75736 12.2426C3.22636 11.7116 3.57855 10.5968 3.30828 9.9436C3.0281 9.26644 2 8.72144 2 7.99998C2 7.27853 3.0281 6.73354 3.30828 6.05639C3.57855 5.40317 3.22636 4.28836 3.75736 3.75736C4.28836 3.22636 5.40317 3.57855 6.0564 3.30828C6.73356 3.0281 7.27856 2 8.00002 2C8.72147 2 9.26646 3.0281 9.94361 3.30828C10.5968 3.57855 11.7116 3.22636 12.2426 3.75736C12.7736 4.28836 12.4214 5.40317 12.6917 6.0564C12.9719 6.73356 14 7.27856 14 8.00002C14 8.72147 12.9719 9.26646 12.6917 9.94361C12.4214 10.5968 12.7736 11.7116 12.2426 12.2426C11.7116 12.7736 10.5968 12.4214 9.9436 12.6917C9.26644 12.9719 8.72144 14 7.99998 14C7.27853 14 6.73354 12.9719 6.05639 12.6917C5.40317 12.4214 4.28836 12.7736 3.75736 12.2426Z",
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.5b0221b0.svg";
export { ForwardRef as ReactComponent };